import { render } from "./VueQRCodeComponent.vue?vue&type=template&id=d8db06fe"
import script from "./VueQRCodeComponent.vue?vue&type=script&lang=js"
export * from "./VueQRCodeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__